export enum ClientPageTab {
  Overview = 'overview',
  StaffingAgencies = 'staffing-agencies',
  People = 'people',
}

export enum PeopleSegment {
  Team = 'team',
  Agencies = 'agencies',
  Client = 'client',
}
